<template>
  <div class="icon-scroll">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="46"
      viewBox="0 0 32 46"
    >

      <g
        fill="none"
        fill-rule="evenodd"
      >
        <!-- eslint-disable max-len -->

        <path
          class="icon-scroll__shape"
          stroke="#FEFEFE"
          stroke-width="2"
          d="M16 1c8.284 0 15 6.707 15 15.004v13.992C31 38.282 24.286 45 16 45 7.716 45 1 38.293 1 29.996V16.004C1 7.718 7.714 1 16 1c8.284 0 15 6.707 15 15.004"
          stroke-dasharray="145.83"
          stroke-dashoffset="145.83"
        />
        <!-- eslint-enable max-len -->
        <path
          class="icon-scroll__path"
          stroke="#FFF"
          stroke-linecap="round"
          stroke-width="4"
          d="M16 13v5.28"
          stroke-dasharray="5.30"
          stroke-dashoffset="5.30"
        />

      </g>

    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconScroll'
};
</script>

<style lang="scss" src="@/assets/icons/icon-scroll-view.scss"></style>



// WEBPACK FOOTER //
// icon-scroll-view.vue